<template>
  <div class="d-flex align-items-center justify-content-center height-100vh">
    <div
      v-if="loading"
      class="spinner-border"
      role="status"
    >
      <span class="sr-only">Loading...</span>

    </div>
    <div v-if="!loading">
      <h5>Complete Your Payment</h5>
      <div class="d-flex align-items-center justify-content-center">
        <b-button
          type="button"
          variant="primary"
          @click="redirectToPayHere()"
        >
          Pay Now
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BButton,
} from 'bootstrap-vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { apiUrl, tenant } from '@/constants/config'

const PaymentRepository = RepositoryFactory.get('payment')

export default {
  components: {
    BButton,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return {
      loading: false,
      id: null,
      name: null,
      data: [],
      actionUrl: '',
    }
  },
  created() {
    this.id = this.$route.params.id
    this.name = this.$route.params.name
    this.fetchQRDetails()
  },
  methods: {
    async fetchQRDetails() {
      this.loading = true
      try {
        const response = (await PaymentRepository.getCheckoutData(this.id, this.name)).data
        this.data = response.data.payhere_data
        this.actionUrl = response.data.action_url
        this.data.cancel_url = `${this.data.cancel_url}/${this.id}/${this.name}`
        this.data.notify_url = `${apiUrl}/payment/notify?tenant=${tenant}`
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    redirectToPayHere() {
      // Create a form element
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = this.actionUrl

      Object.entries(this.data).forEach(([key, value]) => {
        if (Object.prototype.hasOwnProperty.call(this.data, key)) {
          const input = document.createElement('input')
          input.type = 'hidden'
          input.name = key
          input.value = value
          form.appendChild(input)
        }
      })

      // Append the form to the body
      document.body.appendChild(form)

      // Automatically submit the form to redirect the user
      form.submit()
    },
  },
}
</script>

<style lang="scss">

</style>
